export const DASHBOARD_EXPERIENCE_TELEMETRY_EVENTS = {
  pageLanded: 'dashboard_experience_page_landed',
  apiSuccess: 'dashboard_experience_api_success',
  uiRendered: 'dashboard_experience_ui_rendered',
} as const
